import { render, staticRenderFns } from "./EditRevenueShare.vue?vue&type=template&id=72cfb03f"
import script from "./EditRevenueShare.vue?vue&type=script&lang=js"
export * from "./EditRevenueShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports